module.exports = __webpack_public_path__ + "static/media/foood-chain-blockchain-and-robotics-desktop.e5cf7532.jpg";